import React from "react";
import "./About.css";

function About() {
  return (
    <div className="about">
      <h1 className="about-title">About Me</h1>

      <div className="professional">
        <h1>
          <em>Professional front</em>
        </h1>

        <p>
          Throughout my engineering years, I have realized an important fact
          that its tough being good at everything,but there's a better edge in
          working towards one thing and getting really good at it.
          <br />
          <br />
          Due to course requirements or my own adventures/misadventures I have
          worked on Java, Web Dev, App dev, Designing, Marketing, Digital
          marketing, and PPC, Analytics, AI-ML only to realize that it's tough
          for me to achieve mastery in all the above fields, that is when I
          decided to dive deep into Web dev and concentrate on Web Development.
          <br /> <br />I am building and learning web apps with MERN stack and
          striving to get better at developing a fully functional and efficient
          website that would solve the problem it was intended to build. <br />
          <br />
          I have recently completed my internship at J.P. Morgan Chase &
          Co,where I was part of JPMC's Global Real Estate Team and worked on an
          internal Property management website for JPMC's clients. I Worked on
          an entire project lifecycle, right from understanding requirements,
          planning, development, testing, and deployment. I built an API to
          replace the previously hard-coded value in the frontend application to
          now fetch the value from the database and help in future scalability.
          I am glad that I got to work on a real-time, deployed project, housing
          many Fortune 500 companies' assets and properties, and enhanced the
          project by implementing a well-tested scalable, and robust API for
          seamless changes and updates.
          <br />
          <br />I have also completed my internship at Brane Enterprises[NSL
          HUB] as the Quality Assurance Intern, where my responsibility was to
          ensure that the platform is up and running all the time. I have also
          worked in manual testing, API automation testing where I was assigned
          over 950+ test cases along with writing scripts to automate test
          cases.
          <br /> <br /> I bagged an internship from J.P Morgan Chase and Co.
          when I was in the second year of my college after building a product
          in just 24 hours in the annual Code For Good hackathon where there
          were over 6000 participants throughout India in the first round.
        </p>
      </div>
      <hr />
      <div className="personal">
        <h1>
          <em>Personal front</em>
        </h1>
        <p>
          One of the best moments or the journey I have been a part of, in my
          life has to be me starting a digital marketing startup in the first
          year of my college. I had received a piece of advice from one of my
          friends to try out all the fields or whatever interest me in the first
          year of engineering because that’s the best time to explore and get to
          know who we really are as we subsequently get busy.
          <br />
          <br />I learned a lot of valuable life lessons, the importance of
          patience, the importance of health, and the magic of hard work and
          commitment. <br />
          <br /> One of the things which I look up to every day in my life has
          to be working out or fitness in general. I usually tell my friends
          that if a teen walks up to me and asks me for one single piece of
          advice, just one, I would definitely tell them to start working out.
          It’s a true unwinding for me and I have realized the power of
          consistency and raising the bars higher (literally) all thanks to my
          fitness routine.
          <br />
          <br />
          Other than that I enjoy hitting highways or uncrowded famous and
          highly recommended places, offroad trails on my motorcycle. I have
          covered quite a few places in and around Bengaluru on my bike . And
          it’s definitely true that we always enjoy the journey more than the
          destination (Quite literally !) <br />
          <br />
          <em>
            Fun fact: I dropped my new bike on my very first ride(I promise I’m
            not a sloppy driver !)
          </em>
          <br />
          <br />
        </p>
      </div>
    </div>
  );
}

export default About;
